import LocalizationWrapper from "./LocalizationWrapper";

export default LocalizationWrapper;
